import React, { useEffect } from "react";
import {
  Typography, Grid, Button,
} from "@material-ui/core";
import { getMemberList, typeMemberList, } from '../api/helpline/master'
import UserSettingTable from '../component/portal/usersetting/UserSettingTable'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import { useGlobalState } from "../provider/Provider";
import { useHistory, useRouteMatch } from "react-router-dom";

interface Prop {
  handleError: (err: any) => void
}

const UserList: React.FC<Prop> = (props) => {
  const globalState = useGlobalState('user')
  const { userId, token, role } = globalState
  const history = useHistory()
  let { path } = useRouteMatch()
  const { handleError } = props
  //メンバー情報一覧
  const [memberList, setMemberList] = React.useState<typeMemberList[] | undefined>()

  const handleClickCreate = () => {
    history.push(`${path}/create`)
  }

  const handleClickUser = (usercd: string) => {
    history.push(`${path}/${btoa(usercd)}`)
  }

  //初期表示APIコール
  useEffect(() => {
    let cleanup = false
    //メンバー情報一覧取得
    if (userId && token && role) {
      getMemberList(userId, userId, token, role).then(res => {
        res.map(objvalue => {
          for (const [key, value] of Object.entries(objvalue)) {
            if (key === "notes" && value) {
              objvalue["u_departmentName"] = value.replace(/\|(.*?)$/, '')
              objvalue["post"] = value.replace(/^(.*?)\|/, '')
            }
          }
        })
        if (!cleanup) { setMemberList(res) }
      }).catch(err => handleError(err))
    }
    return () => { cleanup = true }
  }, [])

  return (
    <React.Fragment>
      <Grid container direction="row" justify="flex-start">
        <Typography variant="h6" style={{ flexGrow: 1 }}>
          メンバー一覧
      </Typography>
        <Button variant="outlined" color="primary" size="small" startIcon={<AddCircleOutlineIcon />} onClick={handleClickCreate}>
          新規登録
        </Button>
      </Grid>
      <Grid container spacing={2} justify="center" >
        <Grid item xs={11}>
          <UserSettingTable memberList={memberList} handleClickUser={handleClickUser} />
        </Grid>
      </Grid>
    </React.Fragment >
  )
}

export default UserList